/**
 * Created by inonstelman on 12/28/14.
 */

// @ngInject

Models.UserModel = function UserModel(BaseModel, UsersManager, CompanyService, Enums, $, $log, moment, _, ImageService, FeaturesService, AvatarService, SchedulingManager, ModelFactory, AppcuesService){

    var hbUserTypes = {
        regular: 'regular',
        demo: 'demo',
        malkut: 'malkut',
        admin: 'admin',
        honeybook_invoicing: 'honeybook_invoicing',
        honeybook_paying: 'honeybook_paying'
    };

    var hbPermissions = {
        malkut_cs: 'malkut_cs',
        malkut_transfers: 'malkut_transfers',
        malkut_fraud: 'malkut_fraud',
        malkut_recipients: 'malkut_recipients',
        malkut_venue_onboarding: 'malkut_venue_onboarding',
        community_moderator: 'community_moderator',
        restrict_access: 'restrict_access',
        manage_pricing: 'manage_pricing'
    };

    var UserModelClass = Class(BaseModel, {

        constructor: function constructor(){
            UserModelClass.$super.call(this);
            this.__className = 'UserModel';

            this.isMemberOfWorkspace = false;
            this.workspaceId = null;
          //  this.is_hb_admin = false;
        },

        mapChilds: function mapChilds(){
            return {
                creator: 'UserModel',
                company: 'CompanyModel',
                network: 'NetworkUserModel',
                session_configs: 'SessionsCollection'
            };
        },

        afterMixingFrom: function afterMixingFrom(object){
        },

        /**
         * Override this.cachable when you don't want the models to be cached (always fetched from server)
         */
        isCachable: function isCachable() {
            return false;
        },

        _dataOnlyInterceptor: function _dataOnlyInterceptor(copy) {
            delete copy.activity_notifications;
            delete copy.mobile_notifications;
        },

        getAccount: function getAccount() {
            return this.company && this.company.account;
        },

        getSubscription: function getSubscription() {
            const account = this.account;
            if(account && account.subscription) {
                const subscription = ModelFactory.newSubscriptionModel();
                subscription.mixinFrom(account.subscription, null, false);
                return subscription;
            }
        },

        getTrial: function getTrial() {
            return this.getAccount() && this.getAccount().trial;
        },

        isFeatureActive: function isFeatureActive(feature, variation) {
            variation = variation || 'on';

            return (this.features_variations && this.features_variations[feature] === variation) || // splitio
                   (this.features_active && this.features_active.indexOf(feature) !== -1); // rollout
        },

        setAsMemberOfWorkspace: function setAsMemberOfWorkspace(workspaceId){
            this.isMemberOfWorkspace = true;
            this.workspaceId = workspaceId;
        },

        setSystemUserType: function setSystemUserType(type){
            this.system_user_type = type;
        },

        notFirstSession: function notFirstSession(){
            if(this.getTrial()){
                return (new Date() - new Date(this.getTrial().start_date))/3600000 > 1;
            }
            return false;
        },

        hoursAfterTrialStarted: function hoursAfterTrialStarted(hours){
            if(this.getTrial()){
                return (new Date() - new Date(this.getTrial().start_date))/3600000 >= hours;
            }
            return false;
        },

        calendarDaysAfterTrialStarted: function calendarDaysAfterTrialStarted(days){
            if(this.getTrial()){
                return (moment().diff(this.getTrial().start_date, 'days') > days);
            }
            return false;
        },

        startedTrialAfterDate: function startedTrialAfterDate(dateString){ //example dateString: '2019-01-01'
            var startedOnboardingAfterDate = this.getTrial() && moment(dateString).isBefore(this.getTrial().start_date);
            return startedOnboardingAfterDate;
        },

        getTrialStartDate: function getTrialStartDate(){
            let trial = this.getTrial();
            if (trial) {
                return trial.start_date;
            }
            return null;
        },
        setSystemUserTypeAndWorkspaceRole: function setSystemUserTypeAndWorkspaceRole(type){

            if (!this._id || !this.system_user_type) {
                this.system_user_type = type.system_user_type;
            }

            if (this.isMemberOfWorkspace){
                this.workspace_user_data.workspace_role = type.workspace_role;
            }
        },

        _isHbUserType: function _isHbUserType(type){

            if(angular.isArray(this.hb_user_type)){
                return this.hb_user_type.indexOf(type) >= 0;
            }

            return false;
        },

        isClient: function isClient(){
            return this.system_user_type === 'client';
        },

        isVendor: function isVendor(){
            return this.system_user_type === 'vendor';
        },

        isAdmin: function isAdmin(){
            return this._isHbUserType(hbUserTypes.admin);
        },

        // Indicating that this login was done by admin login, if u need to use please consider creating infra for it
        isAdminLogin: function isAdminLogin(){
            return !!this.is_hb_admin;
        },

        isMalkut: function () {
          return this._isHbUserType(hbUserTypes.malkut);
        },

        isDemo: function isDemo(){
            return this._isHbUserType(hbUserTypes.demo);
        },

        isHBInvoicing: function isHBInvoicing(){
            return this._isHbUserType(hbUserTypes.honeybook_invoicing);
        },

        _hasPermission: function (permission) {
            if(angular.isArray(this.hb_system_permissions)){
                return this.hb_system_permissions.indexOf(permission) >= 0;
            }
            return false;
        },

        hasMalkutFraudPremission: function () {
            return this._hasPermission(hbPermissions.malkut_fraud);
        },

        hasMalkutPricingPermissions: function () {
            return this._hasPermission(hbPermissions.manage_pricing);
        },

        hasMalkutCsPremission: function () {
            return this._hasPermission(hbPermissions.malkut_cs);
        },

        hasMalkutTransfersPremission: function () {
            return this._hasPermission(hbPermissions.malkut_transfers);
        },

        hasMalkutRecipientsPremission: function () {
            return this._hasPermission(hbPermissions.malkut_recipients);
        },

        hasMalkutVenueOnboardingPremission: function () {
            return this._hasPermission(hbPermissions.malkut_venue_onboarding);
        },

        hasCommunityModeratorPermission: function () {
            return this._hasPermission(hbPermissions.community_moderator);
        },

        hasMalkutRestrictAccessPermission: function () {
            return this._hasPermission(hbPermissions.restrict_access);
        },


        isHoneyBookPaying: function () {
            return this._isHbUserType(hbUserTypes.honeybook_paying);
        },

        // user is active if logged-in in the past
        isActiveUser: function isActiveUser(){
            return !!this.last_login_time;
        },

        isActivated: function isActivated() {
            return !!this.is_activated;
        },

        getUserStatus: function getUserStatus() {
            if (this.isActivated()) {
                return Enums.UserStatus.activated;
            }
            else if (this.isInTrial()) {
                return Enums.UserStatus.trial;
            }
            else if (this.hasTrialExpired()){
                return Enums.UserStatus.trialExpired;
            }
            else if (!this.companyHasSubscription()) {
                return Enums.UserStatus.preTrialer;
            }

            return null;
        },

        isMobileActive: function isMobileActive() {
            return this.is_mobile_active;
        },

        isCommunitySource: function isCommunitySource() {
            return this.attribution && this.attribution.user_source_primary === "network";
        },

        myBankAccount: function myBankAccount(){

            if (Array.isArray(this.payment_methods) && this.company && this.company.bank_account_user_id === this._id){

                return this.payment_methods.find( function(pm){
                    return pm._id === this.company.bank_account_payment_method_id;
                }.bind(this));
            }

            return undefined;
        },

        myDebitCard() {
            var bank_account = this.myBankAccount();

            if (!bank_account || !bank_account.debit_card_payment_method_id) {
                return null;
            }

            return this.payment_methods.find((method) => bank_account.debit_card_payment_method_id === method._id && method.card_role.includes('instant_payout'));
        },

        printDetails: function printDetails(){
            return this.full_name + ' (' + this.email + ') | id: ' + this.id();
        },

        updateCurrentUserProperties: function updateCurrentUserProperties (userData) {
            return UsersManager.updateCurrentUserProperties(userData);
        },

        changePassword: function changePassword(data) {
            return UsersManager.changePassword(data);
        },

        changePasswordSuccessful: function changePasswordSuccessful() {
            UsersManager.changePasswordSuccessful();
        },

        addPaymentMethod: function addPaymentMethod(paymentMethod, type) {
            paymentMethod.id = null;
            paymentMethod._type = type || Enums.PaymentMethodTypes.creditCard;
            return UsersManager.addPaymentMethod(this, paymentMethod);
        },

        deletePaymentMethod: function deletePaymentMethod(methodId) {
            return UsersManager.deletePaymentMethod(this, methodId);
        },

        addBankAccount: function addBankAccount(account, company, smsCode){
            return UsersManager.addBankAccount(this, account, company, smsCode);
        },

        deleteBankAccount: function deleteBankAccount(account){
            return UsersManager.deleteBankAccount(this, account);
        },

        deselectBankAccount: function deselectBankAccount(accountId) {
            console.log('user model', this._id);
            console.log('user model', accountId);
            return UsersManager.deselectBankAccount(this._id, accountId);
        },

        // Workspace Member functions
        isActiveMemberInWorkspace: function isActiveMemberInWorkspace() {

            if (!this.isMemberOfWorkspace || !this.workspace_user_data) {
                return false;
            }

            return this.workspace_user_data.workspace_member_status === "member_active";
        },

        isInviteSentToWorkspace: function isActiveInWorkspace() {
            if (!this.isMemberOfWorkspace) {
                $log.log("ERROR, should not call this function if not a model of a member");
                return false;
            }
            return this.workspace_user_data.workspace_member_status === "member_invite_sent";
        },

        addUserAction: function addUserAction(actionName){
            return UsersManager.addUserAction(this, actionName);
        },

        hasCompanyAdminPermissions: function hasCompanyAdminPermissions() {
            return CompanyService.hasCompanyAdminPermissions(this, this.company);
        },

        trialDenomination: function trialDenomination() {
            return this.getTrial() && this.getTrial().type;
        },

        hasCompanyModeratorPermissions: function hasCompanyModeratorPermissions() {
            return CompanyService.hasCompanyModeratorPermissions(this, this.company);
        },

        saveDefaultSignature: function saveDefaultSignature(signature) {
            return UsersManager.saveDefaultSignature(this, signature);
        },

        isInTrial: function isInTrial() {
            if (this.getTrial()){
                return !this.getTrial().ended;
            }
            // if the user does not have a trial object on it's company than the default is not blocking the user
            // consider the user in trial
            return false;
        },

        isReferralTrialer: function isReferralTrialer() {
            var referral = this.referral_container && this.referral_container.is_referral_trialer;
            var mbsy = this.attribution.user_utm_params && this.attribution.user_utm_params.utm_mbsy;
            return referral || mbsy;
        },

        isPaidDigitalDiscountTrialer: function isPaidDigitalDiscountTrialer() {
            return this.attribution.user_utm_params && this.attribution.user_utm_params.utm_origin;
        },

        isInTrialAndNotSubscribed: function isInTrialAndNotSubscribed(){
            // True test for if user is a trialer. Does not include users who have paid subscription or never had
            // trial set
            if(this.company){
                if(this.company.subscribed){
                    return false;
                } else if (this.getTrial()){
                    return !this.getTrial().ended;
                } else if (this.getTrial() === null){
                    return false;
                }
            }
            return true;
        },

        companyHasSubscription: function companyHasSubscription() {
            if(this.company){
                return this.company.subscribed;
            }

            // the default should be false
            return false;
        },

        companyHasFreeSubscription: function companyHasFreeSubscription() {
            if(this.company){
                return this.company.subscribed_for_free;
            }

            // the default should be false
            return false;
        },

        companyHasAnySubscription: function companyHasAnySubscription() {
            return this.companyHasSubscription() || this.companyHasFreeSubscription();
        },

        hasTrialExpired: function hasTrialExpired() {
            return this.getTrial() && this.getTrial().ended;
        },

        shouldStartTrial: function shouldStartTrial() {
            if (this.isVendor() &&
                this.company &&
                this.getTrial() == null &&
                this.company.subscribed === false) {
                return true;
            }

            return false;
        },

        isCreatedOverAMonthAgo: function (isCreatedOverAMonthAgo) {
            return moment(this.created_at).isBefore(moment().subtract(1, 'months'));
        },

        isNetworkPretrialer: function isNetworkPretrialer() {
            return (this.attribution && this.attribution.user_source_primary === 'network' && this.shouldStartTrial());
        },

        isProductPretrialer: function isProductPretrialer() {
            return (this.attribution && this.attribution.user_source_primary === 'product' && this.shouldStartTrial());
        },

        hasTrialExpiredDueToNoPayment: function hasTrialExpiredDueToNoPayment() {
            return this.hasTrialExpired() && !this.companyHasSubscription();
        },

        shouldSeeTrialWarnings: function shouldSeeTrialWarnings() {
            var participatesInTrial = !_.isEmpty(this.getTrial()); //if the user has a trial object then he participates in the trial period
            var subscribed = this.companyHasSubscription();
            var inTrialOrTrialExpired = this.hasTrialExpired() || this.isInTrial();

            return participatesInTrial && inTrialOrTrialExpired && !subscribed;
        },

        daysTillTrialEnds: function daysTillTrialEnds() {
            if (this.getTrial()){
                return this.getTrial().days_to_end;
            }

            // if the user does not have a trial object on it's company than return a default
            return 0;
        },

        nTillTrialEnds: function nTillTrialEnds() {
            if (this.getTrial()){
                return this.getTrial().n_to_end;
            }
        },

        isCompanyOwner: function isCompanyOwner() {

            // TODO Alon - Why not use this.is_company_owner ??
            // Dvir: alon why asking questions instead of doing actions?
            // Erez: dvir, why not removing todos if done?
            // Alon: Erez, why are you friends with Dvir?

            if (this.is_company_owner) {
                return true;
            }
            else if (this._id && this.company && this.company.owner){
                return this._id === this.company.owner._id;
            }

            return false;
        },

        isAccountOwner: function isAccountOwner() {
            return !!this.is_account_owner;
        },

        isMyTeamMember: function isMyTeamMember(user){
            var currUser = user || UsersManager.getCurrUser();
            return currUser.company && this.company && currUser.company._id === this.company._id;
        },

        getAvatarFields: function getAvatarFields() {
            return {
                profile_image: $.extend({},this.profile_image),
                first_name: this.first_name,
                last_name: this.last_name,
                company: this.company,
                phone_number: this.phone_number,
                email: this.email
            };
        },

        updateEmailSignature: function updateEmailSignature(signature) {
            return UsersManager.updateEmailSignature(this, signature);
        },

        getCompanyEmailSignatures: function getCompanyEmailSignatures() {
            return this.email_signatures;
        },

        isDefaultProfileImage: function isDefaultProfileImage() {
            return AvatarService.isDefaultProfileImage(this);
        },

        getProfileImage: function getProfileImage(transformation) {

            // first, take user profile image url
            var imageUrl = this.profile_image ? this.profile_image.url : "";

            // if cloudinary id exists, take that
            if(this.profile_image && this.profile_image.cloudinary_public_id) {
                imageUrl = ImageService.getCloudinaryUrl(this.profile_image.cloudinary_public_id, transformation);
            }

            return imageUrl;
        },

        updateAutoExpireDefault: function updateAutoExpireDefault(user, period) {
            if(period === 'never'){
                return UsersManager.deleteAutoExpireDefault(user, period);
            }

            return UsersManager.updateAutoExpireDefault(user, period);
        },

        markActivityNotificationAsSeen: function markActivityNotificationAsSeen(activityNotificationId) {
            UsersManager.markActivityNotificationAsSeen(this, activityNotificationId);
        },

        markConversationNotificationAsSeen: function markConversationNotificationAsSeen(activityNotificationId) {
            UsersManager.markConversationNotificationAsSeen(this, activityNotificationId);
        },

        markAllWebNotificationsAsSeen: function markAllWebNotificationsAsSeen() {
            return UsersManager.markAllWebNotificationsAsSeen(this);
        },

        // markAllUserActivityNotificationsAsSeen: function markAllUserActivityNotificationsAsSeen() {
        //     return UsersManager.markAllUserActivityNotificationsAsSeen(this);
        // },

        getRecentWebNotifications: function getRecentWebNotifications() {
            return UsersManager.getRecentWebNotifications(this);
        },

        getRecentConversationNotifications: function getRecentConversationNotifications() {
            return UsersManager.getRecentConversationNotifications(this);
        },

        getAECalendlyLink: function getAECalendlyLink() {

            return UsersManager.getAECalendlyLink(this);
        },

        getCalendlyWalkthroughDate: function getCalendlyWalkthroughDate() {

            return UsersManager.getCalendlyWalkthroughDate(this);
        },

        getSfdcRecordOwnerEmail: function getSfdcRecordOwnerEmail() {

            return UsersManager.getSfdcRecordOwnerEmail(this);
        },

        getSfdcRecord: function getSfdcRecord() {

            return UsersManager.getSfdcRecord(this);
        },

        isVenueVendor: function () {
            return this.isVendor() && this.company.isVenue();
        },

        isAtwsOrPvlUser: function isAtwsOrPvlUser() {
            return !!this.atws_status;
        },

        getAtwsStage: function getAtwsStage() {
            if(this.isClient()){
                return null;
            }

            if (!_.isEmpty(this.atws_status) && (this.atws_status.onboarding_created === null) && (this.atws_status.trial_created === null)) {
                return Enums.AtwsStage.beforeCreatingFirstEvent;
            } else if (!_.isEmpty(this.atws_status) && (this.atws_status.onboarding_created !== null) && (this.atws_status.trial_created === null)){
                return Enums.AtwsStage.createdFirstEvent;
            } else if  (!_.isEmpty(this.atws_status) && (this.atws_status.onboarding_created !== null) && (this.atws_status.trial_created !== null)){
                return Enums.AtwsStage.createdSecondEvent;
            }

            return null;
        },
        isExampleProposalUser: function isExampleProposalUser(){
            if(this.user_attribution != null && this.user_attribution.pre_first_login_actions != null && this.user_attribution.pre_first_login_actions.length > 0) {
                return this.user_attribution.pre_first_login_actions.indexOf("example_proposal") > -1;
            }
            return false;
        },

        // The user has not yet been converted to a vendor, but signed up
        // with email-only on the homepage.
        shouldShowExampleProposal: function shouldShowExampleProposal() {
            return (this.isExampleProposalUser()) && this.isVendor() && (this.getTrial() == null) && (!this.companyHasSubscription()) ;
        },

        getUnseenNotificationsCount: function getUnseenNotificationsCount() {
            var activityNotifications = this.activity_notifications || [];
            var unseenNotificationsCount = 0;
            activityNotifications.forEach(function (notification) {
                if (notification.seen === false) {
                    unseenNotificationsCount++;
                }
            });
            var conversationNotifications = this.conversation_notifications || [];
            conversationNotifications.forEach(function (notification) {
                if (notification.seen === false) {
                    unseenNotificationsCount++;
                }
            });
            return unseenNotificationsCount;
        },

        hasUnseenNotifications: function hasUnseenNotifications() {
            return this.has_unseen_notifications || this.has_unseen_conversations;
        },

        shouldShowMembershipToUser: function shouldShowMembershipToUser() {
            return this.isAccountOwner() && this.company.shouldShowMembership() && !this.companyHasFreeSubscription();
        },

        shouldBeAbleToUpgrade: function isEligableToPay() {
            return !this.companyHasSubscription() && this.shouldShowMembershipToUser() && this.isVendor();
        },

        securityPhoneNumberLastFourDigits: function securityPhoneNumberLastFourDigits() {

            // this is only the last 4 digits of the actual number
            var phoneNumber = this.phone_number_for_two_factor_auth;
            return phoneNumber;
        },

        isLocatedInUSOrCanada: function isLocatedInUSOrCanada() {
            return UsersManager.isUSOrCanadaBased(this);
        },

        isGoogleIntegrationActive: function isGoogleIntegrationActive(integrationType) {
            var googleIntegrations = this.google_integrations;
            var foundIntegration;
            if(googleIntegrations && googleIntegrations.length > 0) {
                foundIntegration = _.find(googleIntegrations, function (integration) {
                    if(integration.google_integration_permissions) {
                        var foundPermission = _.find(integration.google_integration_permissions, function (permission) {
                            return (permission.integration_type === integrationType && permission.status === 'active');
                        });
                        return foundPermission;
                    }
                });
            }
            return !!foundIntegration;
        },

        getExistingAbTestVariation: function getExistingAbTestVariation(abTestName) {
            return this.ab_tests ? this.ab_tests[abTestName] || null : null;
        },

        setLastSentFileTime: function setLastSentFileTime(time) {
            var lastSentTime = this.last_file_sent_time;
            this.last_file_sent_time = time;
            if (!lastSentTime) {
                this.trigger(Enums.PubSubTriggers.firstPayableFileSent);
            }
        },

        triggerMembershipCancellation: function triggerMembershipCancellation(reason) {
            this.trigger(Enums.PubSubTriggers.membershipCanceled, {reason: reason});
        },

        hasMultipleCompanies: function hasMultipleCompanies() {
            return (this.companies && this.companies.length > 1);
        },

        isNewBrochureEducation: function isNewBrochureEducation() {

            if(!this.company) {
                return false;
            }

            return FeaturesService.isNewForUserByFirstLogin(this, FeaturesService.features.brochureEducation);
        },

        shouldShowClientPortal: function shouldShowClientPortal() {
            return this.isCompanyOwner() && this.companyHasAnySubscription();
        },

        isReferredByMemberReferral: function isReferredByMemberReferral() {
            return this.referral_container && this.referral_container.is_referred_by_member_referral;
        },

        isShowContactFormAwareness() {
            return this.isCompanyOwner() && this.activated_on && !this.company.isContactFormActive()
        },

        getSessions: function getSessions(forUserId, sessionConfigIds, ignoreDayAvailabilities, ignoreTimeFrame) {
            return SchedulingManager.getSessions(this, forUserId, sessionConfigIds, ignoreDayAvailabilities, ignoreTimeFrame).then(function(response) {
                var sessionConfigs = ModelFactory.newCollectionByModelName('SessionModel');
                sessionConfigs.mixinFrom(response.data.session_configs);
                return sessionConfigs;
            }.bind(this));
        },

        createSession: function createSession(session) {
            return SchedulingManager.createSession(this, session).then(function(response) {
                AppcuesService.trackEvent("session_config_created", this);
                var sessionConfigs = ModelFactory.newModel('SessionModel');
                sessionConfigs.mixinFrom(response.data);
                return sessionConfigs;
            }.bind(this));
        },

        updateSession: function updateSession(session) {
            return SchedulingManager.updateSession(this, session);
        },

        deleteSession: function deleteSession(sessionId) {
            return SchedulingManager.deleteSession(this, sessionId);
        },

    });

    return UserModelClass;
};

